const User = {
    id: '',
    idCampana: 18, // solo para pruebas, encontrar una lógica
    idSubmission: '',
    idProgramaAcademico : '',
    idSubmissionType : '1',
    idSubmissionState : '1',
    idLeadPS : '',
    nombres: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    fechaNacimiento: '',
    edad: 0,
    tipoDocPostulante: 1,
    nroDocumento: '',
    nroUbigeoDNI: '',
    genero: '',
    estadoCivil: '',
    emailPersonal: '',
    celular: '',
    idDepartamento: '',
    idProvincia: '',
    idDistrito: '',
    direccion: '',
    telefonoFijo: '',
    institucionProcedencia: '',
    paisResidencia: '',
    nacionalidad: '',
    tipoVivienda: '',
    discapacidad: '',
    tipoDiscapacidad: '',
    noTieneDiscapacidad: true,
    numeroHijos: '0',
    noTengoHijos: '',
    tipoIngresos: '',
    ingresosProfesionales: '',
    ingresosOtros: '',
    ingresosFamiliaresMes: '',
    egresosFamiliaresMes: '',
    noTengoConyugue: '',
    conyugueNombres: '',
    conyugueNombre: '',
    conyugueApellidoPaterno: '',
    conyugueApellidoMaterno: '',
    conyugueFechaNacimiento: '',
    conyugueTipoDoc: '',
    conyugueNroDocumento: '',
    conyugueTelefonoFijo: '',
    conyugueCelular: '',
    conyugueEmailPersonal: '',
    conyuguelCentroLaboral: '',
    conyugueCargo: '',
    conyugueAniosPuesto: '',
    financiamientoTipo: '',
    financiamientoAceptacionCondiciones: '',
    laboralNoLaborando: '',
    laboralCentroTrabajo: '',
    laboralFechaInicio: null,
    laboralRubroEmpresa: '',
    laboralArea: '',
    laboralCargo: '',
    laboralDescripcionCargo: '',
    laboralDescripcion: '',
    laboralDireccion: '',
    laboralTelefono: '',
    laboralEmail: '',
    laboralUrlLinkedin: '',
    cartaPresentacion: '',
    pagoFormaPago: 3,
    pagoTipoComprobante: 3,
    aceptacionDeclaracionJurada: '',
    fechaCreacion: '',
    fechaActuaizacion: '',
    formularioPasoLllenado: '',
    isFinalSubmission: '',
    nivelAcademico: -1,
    nroColegiatura: '',
    vistasCompletadas: '',
    codContacto: '',
    codOportunidad: '',
    codPrograma: 'NONE',
    codEjecutivo: '',
    nombreEjecutivo: '',
    correoEjecutivo: '',
    nomPrograma: '',
    tipoPrograma: '',
    periodo: '',
    nomTipoPrograma: '',
    identidadPueblo : null,
    identidadLengua : null,
    identidadPuebloDetalle : null,
    identidadLenguaDetalle : null,
}

export default User;